import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Input, Paragraph } from '@frontapp/ui-kit';
import { useState } from 'react';
import { Portal } from 'react-portal';

type RequestInputModalProps = {
  message: string;
  button?: string;
};

const RequestInputModal = NiceModal.create(
  ({ message, button = 'OK' }: RequestInputModalProps) => {
    const { hide, resolve, visible, remove } = useModal();
    const [value, setValue] = useState<string>('');

    if (!visible) {
      return null;
    }

    return (
      <Portal>
        <div className="Modal__backdrop">
          <div className="Modal__dialog">
            <Paragraph>{message}</Paragraph>
            <div style={{ marginTop: '15px ' }}>
              <Input
                value={value}
                onChange={setValue}
                placeholder="Insert value"
              />
            </div>
            <div className="Modal__dialog__actions">
              <Button
                onClick={() => {
                  resolve(undefined);
                  hide();
                }}
              >
                Cancel
              </Button>
              <div className="Modal__dialog__actions__flex" />
              <Button
                type="primary-danger"
                onClick={() => {
                  resolve(value);
                  hide();
                }}
              >
                {button}
              </Button>
            </div>
          </div>
        </div>
      </Portal>
    );
  },
);

export async function requestInput(message: string, button?: string) {
  const result = await NiceModal.show<string | undefined>(RequestInputModal, {
    message,
    button,
  });

  return result;
}
